// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* ------------------------------------------------------------------------------------------ */
/* Based on the "Color Tokens" view -------------------------------------------------- */
/* ------------------------------------------------------------------------------------------ */

const colors: Styleguide["colors"] = {
    primary: {
        main: "#461E96",
        contrast: "#ffffff",
        light: "#8C7ED7",
        dark: "#211359",
    },
    secondary: {
        main: "#C1BBEE",
        contrast: "#3B3B3B",
        light: "#DDDBF7",
        dark: "#8C7ED7",
    },
    tertiary: {
        main: "#FFA400",
        contrast: "#3B3B3B",
        light: "#FFF8BA",
        dark: "#F8866D",
    },
    common: {
        border: "#E8E8E8",
        borderLight: "#F5F5F5",
        borderDark: "#A3A3A3",
        accent: "#F5F5F5",
        accentContrast: "#3B3B3B",
        accentContrastLight: "#6E6E6E",
        background: "#ffffff",
        backgroundContrast: "#3B3B3B",
        disabled: "#F5F5F5",
        disabledDark: "#E8E8E8",
    },
    text: {
        main: "#3B3B3B",
        accent: "#1E1E1E",
        disabled: "#6E6E6E",
        link: "#461E96",
        linkHover: "#211359",
        linkAlt: "#3B3B3B",
        linkAltHover: "#461E96",
        input: "#3B3B3B",
    },
    success: {
        main: "#007F50",
        contrast: "#ffffff",
        light: "#007F50",
    },
    warning: {
        main: "#FAEB1E",
        contrast: "#3B3B3B",
        light: "#FAEB1E",
    },
    danger: {
        main: "#E22F00",
        contrast: "#ffffff",
        light: "#E22F00",
    },
    info: {
        main: "#3B3B3B",
        contrast: "#ffffff",
        light: "#3B3B3B",
    },
    neutral: {
        main: "#3B3B3B",
        contrast: "#3B3B3B",
        light: "#e8e8e8",
    },
    invert: {
        main: "#ffffff",
        contrast: "#461E96",
        hover: "#211359",
        dark: "#ffffff",
    },
    placeholder: {
        main: "#6E6E6E",
        disabled: "#6E6E6E",
    },
    button: {
        disabled: {
            main: "#d6d7dc",
            contrast: "#ffffff",
        },
    },
    header: {
        main: "#ffffff",
        contrast: "#272c37",
        hover: "#211359",
        accent: "#461E96",
        accentHover: "#211359",
        accentContrast: "#ffffff",
    },
    menu: {
        mainNavigation: {
            main: "#ffffff",
            contrast: "#211359",
            hover: "#211359",
            underline: "#211359",
            accent: "#211359",
            accentContrast: "#ffffff",
            accentHover: "#211359",
            separator: "#E8E8E8",
            border: "#E8E8E8",
        },
        secondaryNavigation: {
            main: "#461E96",
            contrast: "#ffffff",
            hover: "#ffffff",
        },
        megaMenuWithTabs: {
            tabsBackground: "#F5F5F5",
            tabsBackgroundHover: "#ffffff",
        },
    },
    footer: {
        main: "#F5F5F5",
        contrast: "#3B3B3B",
        alt: "#461E96",
        altContrast: "#ffffff",
    },
    swatch: {
        main: "#E8E8E8",
        contrast: "#3B3B3B",
        hover: "#461E96",
        selected: "#461E96",
        selectedHover: "#211359",
    },
};

export default colors;
